export default __webpack_public_path__ + "static/approval-18c3079be2328121b6471f443663775b.gif";